import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ClerkProviderWrapper from './auth/ClerkProviderWrapper.jsx';
import './index.css';
import 'leaflet/dist/leaflet.css';

// ── PostHog Analytics ─────────────────────────────────────────────────────────
// Opt-out by default (GDPR/ePrivacy compliant — no cookies until user consents).
// ConsentBanner calls posthog.opt_in_capturing() when user clicks Accept.
const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
if (posthogKey) {
  import('posthog-js').then(({ default: posthog }) => {
    posthog.init(posthogKey, {
      api_host:                    'https://eu.i.posthog.com',
      autocapture:                 true,
      capture_pageview:            true,
      opt_out_capturing_by_default: true,
      disable_session_recording:   true,
      persistence:                 'memory',
      loaded: (ph) => {
        const saved = localStorage.getItem('fv_analytics_consent');
        if (saved === 'accepted') {
          ph.opt_in_capturing();
          ph.set_config({ persistence: 'localStorage+cookie' });
        }
      },
    });
    window.__posthog = posthog;
  });
}

// Helper for manual event tracking (use anywhere in the app)
export const track = (event, props = {}) => {
  if (window.__posthog) window.__posthog.capture(event, props);
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ClerkProviderWrapper>
        <App />
      </ClerkProviderWrapper>
    </BrowserRouter>
  </React.StrictMode>
);
